import React, { useEffect } from 'react';
import { ModalContainer, Paragraph } from '@welbe/web-design-system';
import { ContainerFinish } from './FinishModal.styles';
import { ReactComponent as WelbeHappy } from 'App/assets/img/happy-face.svg';

type FinishModalProps = {
	open: boolean;
	close: () => void;
};

export const FinishModal = ({ open, close }: FinishModalProps) => {
	useEffect(() => {
		if (open) {
			setTimeout(() => {
				close();
			}, 4000);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	if (!open) {
		return null;
	}

	return (
		<ModalContainer visible={true} width="400px" height="168px" onClose={close}>
			<ContainerFinish>
				<WelbeHappy />
				<Paragraph fontSize="18px" fontWeight="600" textAlign="center">
					Perfil configurado correctamente
				</Paragraph>
			</ContainerFinish>
		</ModalContainer>
	);
};
